import { track, logError } from '@tracking';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getBusinessType from '@results/selectors/getBusinessType';

export const CART_ORIGIN = 'cart';
export const SHOP_DETAIL_ORIGIN = 'shop_details';
const PRODUCT_DETAILS = 'product_details';

const trackReadMoreClicked = ({
  productSku,
  isReadMore,
  position,
  screenType,
}) => (_, getState) => {
  const EVENT = `${PRODUCT_DETAILS}.${isReadMore ? 'expanded' : 'collapsed'}`;
  try {
    const state = getState();
    const shopId = getShopId(state);
    const businessType = getBusinessType(state);
    const payload = {
      shopId,
      productSku,
      position: position + 1,
      businessType,
      screenType,
      origin: screenType,
    };
    track(EVENT, payload);
  } catch (error) {
    logError(EVENT, error);
  }
};

export default trackReadMoreClicked;
